<ion-header class="ion-no-border">
    <ion-toolbar>
        @if (!closeButton) {
          <ion-button fill="clear" slot="start" (click)="close()">Cancel
          </ion-button>
        }
        <ion-title>Connected Forms</ion-title>
        @if (closeButton) {
          <ion-button fill="clear" slot="end" (click)="close()">
              <ion-icon name="close-outline" sxCursor="pointer" sxTextSize="30px"></ion-icon>
          </ion-button>
        }
    </ion-toolbar>
</ion-header>
<ion-content>
    <div class="qr-card-wrapper" sxCol sxAlign="center" sxPosition="relative" sxHeight="200px">
        <div class="qr-stand">
            <div class="qr-front" sxBackground="light" sxCol sxAlign="center">
                <h3 sxColor="two" sxTextStyle="italic" sxTextWeight="bold">qid</h3>
                <qrcode [qrdata]="baseUrl + scanner.qr" [width]="80"></qrcode>
                <h1 sxColor="three">{{ getQrShortCode() }}</h1>
            </div>
            <div class="qr-leg"></div>
        </div>
    </div>

    @if (activeSlide === slides.selectForms) {
      <div sxPadding="medium">
          <h2 sxMargin="20px 0 0 10px" sxAlign="center">Select Forms</h2>
          <p sxMargin="0 10px 10px" sxTextSize="small" sxColor="two">
              Choose one or more forms to link with this QR Code
          </p>
          <template-selector [(scannerTemplateOptions)]="scanner.scannerTemplateOptions"></template-selector>

          <div sxMargin="10% 0 0 ">
              <super-button [showError]="true" [action]="onFormsSelected">Save
              </super-button>
          </div>
      </div>
    }

    @if (activeSlide === slides.setTitle) {
      <div sxPadding="medium" sxCol sxGap="10px" sxBackground="base"
          sxHeight="full">
          <h2 sxMargin="20px 0 0 10px" sxAlign="center">Set QR Title</h2>
          <p sxMargin="0 10px" sxTextSize="small" sxColor="two">
              Set a title for this QR Code
          </p>
          <super-input label="QR Title" placeholder="Eg. Check-In, Reception QR Stand..." [(value)]="scanner.commonTitle"
              [required]="true"></super-input>
          @if (!scanner?._id) {
            <super-button [showError]="true" [action]="createScanner">Create
            </super-button>
          }
          @if (scanner && scanner._id) {
            <super-button [showError]="true" [action]="update">Update
            </super-button>
          }
      </div>
    }
</ion-content>